import * as React from 'react';

const CartCounter = ({ count  })=>/*#__PURE__*/ React.createElement(React.Fragment, null, count > 0 && /*#__PURE__*/ React.createElement("span", {
        className: "cart-counter",
        "data-t": "cart-counter"
    }, count))
;

export { CartCounter };
//# sourceMappingURL=CartCounter.js.map
